// Minimal pub/sub for a global "is anything loading" flag. Kept outside
// Redux since it's a cross-cutting UI concern (nav clicks, raw axios/fetch
// calls all over the app) rather than app state anything else needs to read.
const listeners = new Set()
let activeCount = 0
let hideTimer = null

const notify = () => {
  const isLoading = activeCount > 0
  listeners.forEach(listener => listener(isLoading))
}

export function startLoading() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  activeCount += 1
  notify()
}

export function stopLoading() {
  activeCount = Math.max(0, activeCount - 1)
  if (activeCount > 0) {
    notify()
    return
  }
  // Small grace period so back-to-back requests (e.g. Login's sequential
  // 2FA check + login call) don't flash the overlay off and on between them.
  hideTimer = setTimeout(() => {
    hideTimer = null
    notify()
  }, 150)
}

export function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function isLoadingNow() {
  return activeCount > 0
}
